export enum WrapUpCategory {
  WON = "won",
  IN_PROGRESS = "in_progress",
  LOST = "lost",
}

export enum WrapUpConfigStepType {
  CLOSE_CONVERSATION = "close_conversation",
  CREATE_FOLLOW_UP = "create_follow_up",
  CREATE_APPOINTMENT = "create_appointment",
  UPDATE_APPOINTMENT = "update_appointment",
  UPDATE_LIFECYCLE = "update_lifecycle",
  UPDATE_INTERESTS = "update_interests",
}

export enum WrapUpConfigFollowUpSuggestionType {
  ONE_HOUR_FROM_NOW = "one_hour_from_now",
  THREE_HOURS_FROM_NOW = "three_hours_from_now",
  ONE_DAY_FROM_NOW = "one_day_from_now",
  THREE_DAYS_FROM_NOW = "three_days_from_now",
  ONE_WEEK_FROM_NOW = "one_week_from_now",
}
